import { useStoreNetwork } from "../store";
import useAPI from "./useAPI";

export default function useNetworks() {
  const api = useAPI();
  const context = useStoreNetwork();

  const loadNetworks = async (refetch = true) => {
    if (!context.isLoaded || refetch) {
      const networks = await api.getNetworks();
      context.setNetworks(networks);
      context.setIsLoaded(true);
      return networks;
    }
    return context.networks;
  }

  const adminNetworks = async () => {
    return await api.getAdminNetworks();
  }

  const adminNetworkById = async (networkId) => {
    const networks = await api.getNetworks();
    return networks.find((network) => network.id === networkId);
  }

  const adminCreateNetwork = async (networkData) => {
    return await api.createAdminNetwork(networkData);
  }

  const adminUpdateNetwork = async (networkId, networkData) => {
    return await api.updateAdminNetwork(networkId, networkData);
  }

  const adminDeleteNetwork = async (networkId) => {
    return await api.deleteAdminNetwork(networkId);
  }

  return {
    networks: context.networks,
    isLoaded: context.isLoaded,
    loadNetworks,
    adminNetworks,
    adminNetworkById,
    adminCreateNetwork,
    adminUpdateNetwork,
    adminDeleteNetwork,
  };
}